module.exports = __webpack_public_path__ + "static/img/3.7d7fe35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/3.png
// module id = BJmB
// module chunks = 0